import {Component} from '@angular/core';

/** Overlapping row of `app-avatar`s, e.g. the reviewers of a pull request. */
@Component({
    selector: 'app-avatar-stack',
    templateUrl: './avatar-stack.component.html',
    styles: `
        :host {
            display: inline-flex;
            flex: none;
            padding-left: 4px;
        }

        :host ::ng-deep > app-avatar {
            margin-left: -4px;
        }
    `
})
export class AvatarStackComponent {
}
